module.exports = "<section class=\"loader-component\">\r\n\t<img src=\"/assets/images/giphy.gif\">\r\n</section>\r\n"